import React, { useEffect, useState } from "react";
import { mapTableRows } from "../../../../../utils";
import { Button, DocumentsList, Modal, NoData, TableAdv } from "../../../../../components";
import { useSelector, useDispatch } from "react-redux";
import { getEmployeeByUiidStart } from "../../../../../redux/slices/employee/employeeSlice";
import { getAllTaxFormDocumentsStart } from "../../../../../redux/slices/document/documentSlice";
import { transformFiles } from "../../../../../utils/transformFiles";
const W2 = () => {
  const dispatch = useDispatch();
  const employeeProfileUiid = useSelector(
    (state) => state.employee.employeeProfileUiid
  );
  const { employeeDetails, loadedTabs } = useSelector(
    (state) => state.employee.currentEmployee
  );

  /////// Load data from redux store
   const documents = useSelector((state) => state.documents.taxForm) || {};
    const tableData = documents?.w2Form || [];

  const { w2Form: w2FormData } = employeeDetails || {};

  // const tableData =
  //   w2FormData && Object.keys(w2FormData).some((key) => key !== "documents")
  //     ? [w2FormData]
  //     : [];
  const columns = [
    {
      key: "year",
      label: "W2",
      sortable: false,
    },

    {
      key: "stateWithheld",
      label: "State Withheld",
      sortable: false,
    },

    {
      key: "amount",
      label: "W-2 Amount",
      sortable: false,
    },
    {
          key: "documents",
          label: "Attachments",
          render: (row) => {
            return (
              <div
                className={`flex items-center gap-1 flex-row ${
                  row?.documents?.length > 0 && "cursor-pointer"
                }`}
                onClick={
                  transformFiles(row?.documents || []).length > 0
                    ? () =>
                        handelDocumetsModal(transformFiles(row?.documents || []))
                    : () => {}
                }
              >
                <span className={`${row?.documents.length > 0 && "text-linkblue"}`}>
                  {transformFiles(row?.documents).length} Docs{" "}
                </span>
                <div>
                  <Button
                    type="icon"
                    icon="docs"
                    size="xs"
                    variant="text"
                    color="black"
                  />
                </div>
              </div>
            );
          },
        },

    {
      key: "actions",
      label: "Actions",
      render: (row) => (
        <div className="flex items-center gap-2 flex-row">
          <Button
            type="icon"
            icon="edit"
            size="xs"
            variant="text"
            color="black"
          />
          {/* <Button
              type="icon"
              icon="delete"
              size="xs"
              variant="text"
              color="black"
            /> */}
        </div>
      ),
      sortable: false,
    },
  ];
  const mappedRows = mapTableRows(tableData, columns);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedDocuments, setSelectedDocuments] = useState([]);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const handelDocumetsModal = (documents) => {
    setSelectedDocuments(documents);
    setIsModalOpen(true);
  };
 useEffect(() => {
     if (employeeProfileUiid) {
       dispatch(
         getAllTaxFormDocumentsStart({
           tab: "w4FormTab",
           ret: "w2Form",
           coll: "EmpTaxform",
           fil: {
             employeeId: {
               type: "NONE",
               value: employeeProfileUiid,
             },
             taxType: {
               type: "NONE",
               value: 2,
             },
           },
           ref: "Document",
         })
       );
     }
 }, [employeeProfileUiid, loadedTabs, dispatch]);
  return (
    <div className="mt-3">
      <TableAdv tableId={`employee_documents_w2`} rows={mappedRows} columns={columns} hideToolBar />
       <Modal
        width="max-w-2xl"
        title={"Document Details"}
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
      >
        <DocumentsList data={selectedDocuments} />
      </Modal>
    </div>
  );
};

export default W2;
